import { WSService } from "../../../utils/WSService";
import type { userApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/user");

export async function getUserProfile(): Promise<userApiSpec.UserProfileResponse> {
  const { data } = await service.get("");
  return data;
}
